import React from 'react';
import { ShimmeredDetailsList, MessageBar, MessageBarType } from 'office-ui-fabric-react';
import useAPI from '../../../hooks/useAPI';
import { fetchStagedTransactionSummary } from '../../../actions/driStats';
import CardHeader from '../../../components/CardHeader';
import SubModule from '../../../components/SubModule';
import ModuleContent from '../../../components/ModuleContent';

const moduleContent = (error, isLoading, data) => {
  if (error) {
    return (
      <MessageBar
        isMultiline={false}
        messageBarType={MessageBarType.error}
        dismissButtonAriaLabel="Close"
      >
        {error.name}: Try reloading or contact support.
      </MessageBar>
    );
  }
  return <ShimmeredDetailsList enableShimmer={isLoading || !data} items={data} />;
};

const StagedTransactions = () => {
  const { error, data, isLoading } = useAPI(fetchStagedTransactionSummary);

  return (
    <>
      <CardHeader variant="large" leftBorder>
        Staged Transaction Summary
      </CardHeader>
      <SubModule>
        <ModuleContent>{moduleContent(error, isLoading, data)}</ModuleContent>
      </SubModule>
    </>
  );
};

export default StagedTransactions;
